import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Taylor/subs.vtt';
import poster from '@/static/assets/reviews/Taylor/video.jpg';

export const Taylor: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Taylor',
  videoUrl: `${ASSETS_URL}/car/Taylor.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
